module.exports = __webpack_public_path__ + "static/media/SSL.5fa60624.png";